import { useEffect, useState } from 'react'

interface Remaining {
  hours: number
  minutes: number
  seconds: number
}

function getEndOfDay(): number {
  const end = new Date()
  end.setHours(23, 59, 59, 999)
  return end.getTime()
}

function getRemaining(target: number): Remaining {
  const diff = Math.max(0, target - Date.now())
  const totalSeconds = Math.floor(diff / 1000)
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  }
}

export function useCountdown(): Remaining {
  const [target] = useState<number>(() => getEndOfDay())
  const [remaining, setRemaining] = useState<Remaining>(() => getRemaining(target))

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(getRemaining(target))
    }, 1000)
    return () => window.clearInterval(id)
  }, [target])

  return remaining
}
